import { useMemo, useEffect, useRef } from 'react'
import { NavItem, TopNav, useNavigationContext, navActions, AccordionWrapper } from '@panwds/react-nav'
import SubNavItem from './SubNavItem'
import NavIcon from '../common/NavIcon'
import { renderTitle, getNavBadgeProps } from './navUtils'
import './LeftNav.scss'
import type { VFC } from 'react'
import type { NavItem as NavItemType, StoreState } from '../../framework/microAppTypes'

type TopNavProps = {
  state: StoreState
  leftNavDisplayItems: NavItemType[]
  activeNavItem: NavItemType | undefined
  activeSubNavItem: NavItemType | undefined
}
const TopNavigation: VFC<TopNavProps> = ({ state, leftNavDisplayItems, activeNavItem, activeSubNavItem }) => {
  const context = useNavigationContext()
  const contextRef = useRef(context)
  contextRef.current = context

  const navItems = useMemo(() => {
    const renderSubNavItems = (children: NavItemType[] | undefined, multiAccordion?: boolean) => {
      if (!children?.length) {
        return null
      }
      const hasSubNavSibling = children.some((child) => child?.children?.length)
      const rendered = children.map((child: any) => {
        return <SubNavItem key={child.key} item={child} activeSubNavItem={activeSubNavItem} hasSubNavSibling={hasSubNavSibling} favorites={state?.preferences?.tsgs?.current?.favorites}/>
      })
      if (hasSubNavSibling && !multiAccordion) {
        return <AccordionWrapper>{rendered}</AccordionWrapper>
      }
      return rendered
    }
    return leftNavDisplayItems?.map((item: NavItemType) => {
      return <NavItem
        title={renderTitle(item.title) as string}
        id={item.key}
        url={item.navPath || item.path}
        key={item.key}
        disabled={item.disabled as boolean}
        icon={<NavIcon icon={item.icon} />}
        active={activeNavItem === item}
        dataTestId={item.path || item.key}
        {...getNavBadgeProps(item)}
      >
        {renderSubNavItems(item.children?.filter((child) => child?.path || child?.children), item.multiAccordion)}
      </NavItem>
    }) || null
  }, [leftNavDisplayItems, activeNavItem, activeSubNavItem, state?.preferences?.tsgs])

  const needAutoCollapse = activeNavItem?.autoCollapse || activeSubNavItem?.autoCollapse
  // const autoCollapsedId = needAutoCollapse ? activeNavItem?.id : undefined
  // const autoCollapseRef = useRef(autoCollapsedId)
  // autoCollapseRef.current = autoCollapsedId
  useEffect(() => {
    const { collapsed, dispatch } = contextRef.current
    // let autoCollapsed = false
    if (needAutoCollapse && !collapsed) {
      dispatch({ type: navActions.toggleCollapse })
      dispatch({ type: navActions.closeSubNav })
      // autoCollapsed = true
    }
    // return () => {
    //   if (autoCollapsed && !autoCollapseRef.current) {
    //     dispatch({ type: navActions.toggleCollapse })
    //     dispatch({ type: navActions.openSubNav, payload: autoCollapseRef.current })
    //   }
    // }
  }, [needAutoCollapse, activeNavItem]) // ensure activeNavItem change will trigger

  return (
    <TopNav addClassName='sparky-nav-top'>
      {navItems}
    </TopNav>
  )
}

export default TopNavigation
